import { FC, useState } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { editReportVersionVulnerabilityFileRoute, reportVersionVulnerabilityRoute } from "app/route/Routes";
import { useRouteParams } from "app/route/route";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { UpdateReportVulnerabilityFileForm } from "app/component/report-vulnerability-file/UpdateReportVulnerabilityFileForm.tsx";

export const EditReportVersionVulnerabilityFileScreen: FC = () => {
    const { reportId, versionId, vulnerabilityId, fileId } = useRouteParams(editReportVersionVulnerabilityFileRoute);
    const [created, setUpdated] = useState(false);

    return created ? (
        <Navigate to={reportVersionVulnerabilityRoute.build({ reportId, versionId, vulnerabilityId })} />
    ) : (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={editReportVersionVulnerabilityFileRoute} />
                <UpdateReportVulnerabilityFileForm fileId={fileId} onUpdate={() => setUpdated(true)} />
            </Container>
        </NavigationScreen>
    );
};
